import { ProtectionLevelText } from "./constants";

/**
 * Helper function to determine if a scenario is effectively mitigated
 * (excluding RISK_ACCEPTED steps from mitigation consideration)
 */
export const isScenarioEffectivelyMitigated = (scenario, fetchedSteps) => {
  if (!scenario.is_mitigated) {
    return false;
  }

  // Check if the scenario has any mitigated steps that are NOT RISK_ACCEPTED
  const hasNonRiskAcceptedMitigatedSteps = scenario.steps.some((stepId) => {
    const step = fetchedSteps[stepId];
    return (
      step &&
      step.is_mitigated &&
      step.protection_level !== ProtectionLevelText.RISK_ACCEPTED
    );
  });

  return hasNonRiskAcceptedMitigatedSteps;
};
